"use client"

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <footer className="bg-gray-900 text-white py-8 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand Info */}
          <div className="text-center md:text-left">
            <h3 className="text-xl sm:text-2xl font-semibold mb-2">Оксана Заякина</h3>
            <p className="text-gray-400 mb-1 sm:mb-2 text-sm sm:text-base">Клинический психолог • Гипнотерапевт</p>
            <p className="text-gray-400 text-sm sm:text-base">Специалист по психосоматике</p>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center md:justify-end gap-4 sm:gap-6">
            <button
              onClick={() => scrollToSection("about")}
              className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base"
            >
              Обо мне
            </button>
            <button
              onClick={() => scrollToSection("services")}
              className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base"
            >
              Услуги
            </button>
            <button
              onClick={() => scrollToSection("prices")}
              className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base"
            >
              Цены
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base"
            >
              Контакты
            </button>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 sm:pt-8 text-center">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-gray-400 text-xs sm:text-sm">&copy; 2025 Оксана Заякина. Все права защищены.</p>
            <p className="text-gray-400 text-xs sm:text-sm">Конфиденциальность гарантирована</p>
          </div>
          <div className="mt-6">
            <p className="text-gray-500 text-xs sm:text-sm leading-snug">
              Заякина Оксана Геннадьевна<br />
              ИНН 560911168842<br />
              Услуги оказываются без привлечения работников
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
